
//@ts-ignore
import preheater_1 from '@/components/VERTCVideo/assets/interview_greeting.mp3' //该行能够正常运行，重复编译报错，使用@ts-ignore忽略就是了
//@ts-ignore
import preheater_2 from '@/components/VERTCVideo/assets/personal_statement.mp3' //该行能够正常运行，重复编译报错，使用@ts-ignore忽略就是了
import VERTC, { IRTCEngine, VideoSourceType } from '@volcengine/rtc';
import { RoomProfileType } from '@volcengine/rtc';
// import { StreamIndex, MediaType } from '@volcengine/rtc';
import { StreamIndex } from '@volcengine/rtc';
import RTCBeautyExtension from '@volcengine/rtc/extension-beauty';
import { EffectBeautyMode } from '@volcengine/rtc/extension-beauty';
import { defineComponent, inject } from 'vue';
import room from '@/api/room';

// Safari兼容性检查
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const isFFmpegSupported = typeof SharedArrayBuffer !== 'undefined';

// 只在支持的浏览器中加载FFmpeg
let ffmpeg: any = null;
if (isFFmpegSupported && !isSafari) {
    // @ts-ignore
    const { createFFmpeg } = require('@ffmpeg/ffmpeg');
    ffmpeg = createFFmpeg({ 
        corePath: "https://unpkg.shop.jd.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js", 
        log: true 
    });
} else {
    // 创建一个模拟的ffmpeg对象，避免空指针
    ffmpeg = {
        isLoaded: () => false,
        load: () => Promise.resolve(),
        FS: () => {},
        exit: () => {},
        run: () => Promise.resolve()
    }
}

const { uploadAudio, uploadVideo, playRemoteAudio,analyzeInterview, generateFeedback } = room

// import '@/api/mock/room';
import cameraManager from '@/utils/CameraManager.js'
interface Data {
    isProcessing: boolean
    beautyExtension: RTCBeautyExtension | null;
    videoChunks: Blob[];
    videoRecorder: MediaRecorder | null;
    ffmepgDownloading: boolean;
    processedVideoBlob: Blob | null;
    processedTextBlob: Blob | null;
    // 本地媒体流 & 音频上下文，方便统一关闭
    videoStream: MediaStream | null;
    audioStream: MediaStream | null;
    audioContext: (AudioContext | null) | (any | null);
    // audioReplyQueue: string[];
    // 新增：预设视频列表
    presetVideos: string[];
}
//控制变量如果不放在这里，似乎会触发一些线程安全问题
let isMetaHumanThinkingAuido = false
let isMetaHumanTalkingAudio = false
let preheaterPlayed = false
let preheaterPlayDone = false
let timer = 0
const maxPadding = 3
let leftPadding = maxPadding //每隔1s减1
const audio = new Audio()
const audioReplyQueue = [preheater_1, preheater_2]
export default defineComponent({
    props: {
        refName: {
            type: String,
            required: true
        },
        whiteIntensity: {
            type: Number,
            required: false,
            default: 0
        },
        smoothIntensity: {
            type: Number,
            required: false,
            default: 0
        },
        sharpenIntensity: {
            type: Number,
            required: false,
            default: 0
        },
        filterIntensity: {
            type: Number,
            required: false,
            default: 0
        },
        filterType: {
            type: String,
            required: false,
            default: '不使用'
        },
        closeVideoTransfer: {
            type: Boolean,
            required: false,
            default: false
        },
        closeAudioTransfer: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        whiteIntensity(newValue) { this.beautyExtension?.setBeautyIntensity(EffectBeautyMode.EFFECT_WHITE_MODE, newValue) },
        smoothIntensity(newValue) { this.beautyExtension?.setBeautyIntensity(EffectBeautyMode.EFFECT_SMOOTH_MODE, newValue) },
        sharpenIntensity(newValue) { this.beautyExtension?.setBeautyIntensity(EffectBeautyMode.EFFECT_SHARPEN_MODE, newValue) },
        ffmepgDownloading(newValue) {
            if (newValue) this.$emit('ffmpegStartDownloading')
            else this.$emit('ffmpegStopDownloading')
        }
    },
    data() {
        return {
            isProcessing: false,
            beautyExtension: null,
            videoChunks: [],
            videoRecorder: null,
            ffmepgDownloading: false,
            processedVideoBlob: null,
            processedTextBlob: null,
            videoStream: null,
            audioStream: null,
            audioContext: null,
            // 新增：预设视频列表 - 这里可以放置3个预设视频的路径
            presetVideos: [
                '/preset_videos/video1.mp4',
                '/preset_videos/video2.mp4', 
                '/preset_videos/video3.mp4'
            ]
        } as Data
    },
    async mounted() {
        // 只在支持FFmpeg的浏览器中加载
        if (ffmpeg && !ffmpeg.isLoaded()) {
            this.ffmepgDownloading = true
            try {
                await ffmpeg.load()
            } catch (error) {
            }
            this.ffmepgDownloading = false
        }
        const self = this //获取上下文
        const config = {
            appId: '填写项目的 appID',
            roomId: '填写 roomId',
            uid: '填写 uid',
            token: '填写 token',
        }
        const engine: IRTCEngine = VERTC.createEngine(config.appId)
        const join = async () => {
            try {
                await engine
                    .joinRoom(
                        config.token,
                        config.roomId,
                        {
                            userId: config.uid,
                        },
                        {
                            isAutoPublish: false, // 采集音视频时自动发布到房间
                            isAutoSubscribeAudio: true, // 自动订阅音频
                            isAutoSubscribeVideo: true, // 自动订阅视频
                            roomProfileType: RoomProfileType.communication // 自 V4.51 ，无需设置该项。同时，设置不会无效。普通音视频通话模式，例如，语音聊天室
                        }
                    )
            } catch (e) {
                console.error('进房错误：', (e as {
                    code: typeof VERTC.ErrorCode;
                    message: string;
                }).message);
            }
        }
        const readyToConnect = false
        if (readyToConnect) join()
        const createLocalStream = async () => {
            //基础美颜
            const beautyExtension = new RTCBeautyExtension()
            try {
                await engine.registerExtension(beautyExtension)
            } catch (error) {
                console.log((error as { message: string }).message)
            }
            // const options = { video: true, audio: true }; // 请求启用视频和音频
            // const answer = await VERTC.enableDevices(options);
            const videoDevices: MediaDeviceInfo[] = await VERTC.enumerateVideoCaptureDevices()
            const audioDevices: MediaDeviceInfo[] = await VERTC.enumerateAudioCaptureDevices()
            if (videoDevices.length == 0) console.error('找不到摄像头设备')
            if (audioDevices.length == 0) console.error('找不到麦克风设备')
            // 开启本地采集engine
            // await engine.startVideoCapture(videoDevices[0].deviceId) //不再直接拿取摄像头视频流
            // await engine.startAudioCapture()
            // 设置本地播放器
            navigator.mediaDevices.getUserMedia({
                video: { deviceId: { exact: videoDevices[0].deviceId } },
                audio: { deviceId: { exact: audioDevices[0].deviceId } }
            })
                .then(async (stream) => {
                    this.videoStream = stream
                    // //这里使用截获到的视频流，比如：将视频流绑定到 video 元素
                    // (this.$refs.video as HTMLVideoElement).srcObject = stream
                    // 现在开始对捕获到的摄像头视频流做预处理
                    // 关于风格滤镜，另一种方案是在摄像头上加一个透明遮罩，这能显著降低能耗，不过这样就不是处理视频流了
                    const track = stream.getVideoTracks()[0]
                    const video = document.createElement('video')
                    video.srcObject = new MediaStream([track])
                    await video.play()
                    const canvas = document.createElement('canvas')
                    const ctx = canvas.getContext('2d', { willReadFrequently: true })
                    canvas.width = video.videoWidth
                    canvas.height = video.videoHeight
                    const filterNames = ['不使用', '标准', '樱桃红']
                    const filterEffects = [{ R: 0, G: 0, B: 0 }, { R: 10, G: 5, B: 5 }, { R: 20, G: 0, B: 0 }]
                    const preprocessFrames = () => {
                        // 画出当前视频帧
                        ctx!.drawImage(video, 0, 0)
                        const imageData = ctx!.getImageData(0, 0, canvas.width, canvas.height)
                        const data = imageData.data
                        const red = filterEffects[filterNames.indexOf(this.filterType)].R * this.filterIntensity
                        const green = filterEffects[filterNames.indexOf(this.filterType)].G * this.filterIntensity
                        const blue = filterEffects[filterNames.indexOf(this.filterType)].B * this.filterIntensity
                        if (this.filterType != '不使用') {//节省运算
                            for (let i = 0; i < data.length; i += 8) {//原则上应该对所有像素点做运算，但是太烧电了，这里间隔单个像素点做渲染
                                data[i] = Math.max(Math.min(data[i] + red, 255), 0)     // 红色通道
                                data[i + 1] = Math.max(Math.min(data[i + 1] + green, 255), 0) // 绿色通道
                                data[i + 2] = Math.max(Math.min(data[i + 2] + blue, 255), 0) // 蓝色通道
                            }
                        }
                        ctx!.putImageData(imageData, 0, 0)
                        requestAnimationFrame(preprocessFrames)
                    }
                    preprocessFrames()
                    const newTrack = canvas.captureStream().getVideoTracks()[0]
                    engine.setVideoSourceType(StreamIndex.STREAM_INDEX_MAIN, VideoSourceType.VIDEO_SOURCE_TYPE_EXTERNAL)
                    engine.setExternalVideoTrack(StreamIndex.STREAM_INDEX_MAIN, newTrack)
                    engine.setLocalVideoPlayer(StreamIndex.STREAM_INDEX_MAIN, {
                        // renderDom 为容器元素的 id。可以为一个空的 div 标签，如 <div id="local-player"></div>
                        renderDom: this.refName
                    })
                    const mediaRecorder = new MediaRecorder(stream)
                    const videoChunks: Blob[] = []
                    self.videoChunks = videoChunks
                    mediaRecorder.ondataavailable = event => {
                        if (mediaRecorder.state == 'recording') {
                            timer++
                            leftPadding--
                            videoChunks.push(event.data)
                        }
                    }
                    self.videoRecorder = mediaRecorder
                    const timeslice = 1000
                    self.videoRecorder?.start(timeslice) //每1s触发ondataavailable
                    self.videoRecorder?.pause()
                    // setInterval(() => {
                    //   if (self.closeVideoTransfer) return
                    //   console.log('开始视频录制')
                    //   mediaRecorder.start()
                    //   setTimeout(() => {
                    //     console.log('结束视频录制')
                    //     mediaRecorder.stop()
                    //   }, 5000)
                    // }, 60000)
                })
            navigator.mediaDevices.getUserMedia({ audio: { deviceId: { exact: audioDevices[0].deviceId } } })
                .then((stream) => {
                    this.audioStream = stream
                    let isAudioLoading = false
                    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
                    this.audioContext = audioContext
                    const mediaStreamSource = audioContext.createMediaStreamSource(stream);
                    const analyser = audioContext.createAnalyser();
                    analyser.fftSize = 2048;
                    mediaStreamSource.connect(analyser);
                    const dataArray = new Uint8Array(analyser.frequencyBinCount);
                    const threshold = 50; // 设置音量阈值（可调）
                    const mediaRecorder = new MediaRecorder(stream)
                    const audioChunks: Blob[] = []
                    mediaRecorder.ondataavailable = event => {
                        audioChunks.push(event.data)
                    }
                    mediaRecorder.onstop = async () => {
                        const minSeconds = 6
                        if (!this.closeAudioTransfer && timer >= minSeconds) {
                            isMetaHumanThinkingAuido = true
                            let audioBlob = new Blob(audioChunks, { type: 'audio/wav' })
                            const arrayBuffer = await audioBlob.arrayBuffer()
                            const uint8Array = new Uint8Array(arrayBuffer)
                            ffmpeg.FS('writeFile', 'input.wav', uint8Array)
                            await ffmpeg.run('-i', 'input.wav', 'output.wav')
                            const data = ffmpeg.FS('readFile', 'output.wav')
                            audioBlob = new Blob([new Uint8Array(data.buffer) as BlobPart], { type: 'audio/wav' })
                            const formData = new FormData()
                            formData.append('file', audioBlob, 'recording.wav')
                            formData.append('interview_id', self.$store.state.interviewState.interviewId)
                            uploadAudio(formData)
                                .then(response => {
                                    console.log('音频文件成功上传:', response.data)
                                    const dialogue = { original_text: response.data.original_text, processed_text_from_llm: response.data.processed_text_from_llm }
                                    this.$store.dispatch('interviewState/dialogueInteract', dialogue)
                                    playRemoteAudio(response.data.audio).then(response => {
                                        const audioUrl = URL.createObjectURL(response.data)
                                        audioReplyQueue.push(audioUrl)
                                        isMetaHumanThinkingAuido = false
                                        if (isMetaHumanTalkingAudio) isMetaHumanTalkingAudio = false
                                    }).catch(error => {
                                        console.error(error)
                                        isMetaHumanThinkingAuido = false
                                        if (isMetaHumanTalkingAudio) isMetaHumanTalkingAudio = false
                                    })
                                }).catch(error => {
                                    console.error(error)
                                    isMetaHumanThinkingAuido = false
                                    if (isMetaHumanTalkingAudio) isMetaHumanTalkingAudio = false
                                })
                        } else if (!this.closeAudioTransfer && timer < minSeconds) self.$message('听不清楚哦~请您再说慢一点，声音大一些吧~')
                        while (audioChunks.length > 0) { audioChunks.pop() }
                    }
                    const checkVolume = () => {
                        if (isMetaHumanThinkingAuido) {
                            requestAnimationFrame(checkVolume)
                            console.log('waiting for audio reply...')
                            if (!isMetaHumanTalkingAudio && audioReplyQueue.length > 0) {
                                isMetaHumanTalkingAudio = true
                                const audioUrl = audioReplyQueue.shift()
                                // const audio = new Audio(audioUrl)
                                audio.src = audioUrl + ''
                                audio.load()
                                audio.play()
                                audio.addEventListener('ended', () => {
                                    URL.revokeObjectURL(audioUrl + '')
                                })
                            }
                            return
                        }
                        analyser.getByteFrequencyData(dataArray);
                        const volume = dataArray.reduce((sum, value) => sum + value, 0) / dataArray.length;
                        if (volume > threshold && preheaterPlayDone) {
                            if (!isAudioLoading) {
                                console.log('音量超过阈值，开始录音及录像')
                                mediaRecorder.start() // 开始录音
                                timer = 0
                                if (!this.closeVideoTransfer && self.videoRecorder?.state == 'paused')
                                    self.videoRecorder?.resume()
                                isAudioLoading = true
                            }
                            else leftPadding = maxPadding
                        } else {
                            if (isAudioLoading && leftPadding <= 0) {
                                console.log('音量低于阈值，停止录音及录像')
                                mediaRecorder.stop() // 停止录音
                                if (self.videoRecorder?.state == 'recording') self.videoRecorder?.pause() //停止录像
                                isAudioLoading = false
                            }
                        }
                        requestAnimationFrame(checkVolume)
                    };
                    // 开始监控音量
                    checkVolume()
                })
            //基础美颜-美白/磨皮/锐化
            beautyExtension.setBeautyIntensity(EffectBeautyMode.EFFECT_WHITE_MODE, this.whiteIntensity)
            beautyExtension.setBeautyIntensity(EffectBeautyMode.EFFECT_SMOOTH_MODE, this.smoothIntensity)
            beautyExtension.setBeautyIntensity(EffectBeautyMode.EFFECT_SHARPEN_MODE, this.sharpenIntensity)
            beautyExtension.enableBeauty()
            this.beautyExtension = beautyExtension
            // 如果调用 joinRoom 时在 config 中设置了自动发布，这里就不需要发布了
            // await engine.publishStream(MediaType.AUDIO_AND_VIDEO)
        }
        createLocalStream()
    },
    beforeDestroy() {
        // @ts-ignore
        this.stopMedia && this.stopMedia()
    },
    methods: {
        startRecording() {
            this.videoRecorder?.resume()
        },

        // 统一关闭摄像头 / 麦克风 / 音频分析等资源，供上层在离开面试页时调用
        stopMedia() {
            try {
                // 停止视频录制
                if (this.videoRecorder && this.videoRecorder.state !== 'inactive') {
                    try { this.videoRecorder.stop() } catch (e) {}
                }
                // 标记关闭音频上传
                // 注意：closeAudioTransfer / closeVideoTransfer 是父组件传入的 props，这里只负责停止本组件内部的流

                // 停止本地视频轨道
                if (this.videoStream) {
                    this.videoStream.getTracks().forEach(track => track.stop())
                    this.videoStream = null
                }
                // 停止本地音频轨道
                if (this.audioStream) {
                    this.audioStream.getTracks().forEach(track => track.stop())
                    this.audioStream = null
                }
                // 关闭 AudioContext，释放音频分析资源
                if (this.audioContext) {
                    try { this.audioContext.close() } catch (e) {}
                    this.audioContext = null
                }
            } catch (e) {
                console.error('stopMedia 关闭媒体资源时出错:', e)
            }
        },

        // 新增：随机选择预设视频并上传，但下载的是录制的视频
        async uploadPresetVideo(isShortInterview = false) {
            try {
                // 处理录制的视频用于下载
                const videoChunks = this.videoChunks;
                if (videoChunks.length === 0) {
                    console.log('没有录制的视频内容');
                    this.$emit('done');
                    return;
                }
                
                // 直接使用录制的视频，不进行任何处理
                const recordedVideoBlob = new Blob(videoChunks, { type: 'video/mp4' });
                
                // 保存录制的视频用于下载
                this.processedVideoBlob = recordedVideoBlob;
                
                // 通知父组件录制的视频文件已准备就绪
                this.$emit('videoReady', {
                    blob: recordedVideoBlob,
                    size: recordedVideoBlob.size,
                    type: 'video'
                });
                
                // 同时保存到store中
                this.$store.dispatch('interviewState/setProcessedVideo', recordedVideoBlob);
                
                // 准备对话记录
                const dialogues = this.$store.state.interviewState.formattedDialogues;
                const txtBlob = new Blob([dialogues], { type: 'text/plain' });
                
                // 保存文本文件到组件状态
                this.processedTextBlob = txtBlob;
                
                // 通知父组件文本文件已准备就绪
                this.$emit('textReady', {
                    blob: txtBlob,
                    size: txtBlob.size,
                    type: 'text'
                });
                
                // 同时保存到store中
                this.$store.dispatch('interviewState/setProcessedText', txtBlob);
                
                // 不足5分钟的面试不调用analyzeInterview接口
                if (!isShortInterview) {
                    // 静默处理预设视频上传（用户无感知）
                    await this.uploadPresetVideoSilently();
                } else {
                    console.log('面试时长不足5分钟，跳过analyzeInterview接口调用');
                    // 手动触发done事件，让父组件知道处理完成
                    this.$emit('done');
                }
                
            } catch (error) {
                console.error('视频处理失败:', error);
                this.$message.error('视频处理失败');
                this.$emit('done');
            }
        },

        // 静默上传预设视频，用户无感知
        async uploadPresetVideoSilently() {
            let presetVideoBlob: Blob;
            
            try {
                // 随机选择一个预设视频
                const randomIndex = Math.floor(Math.random() * this.presetVideos.length);
                const selectedVideoPath = this.presetVideos[randomIndex];
                
                console.log(`静默上传预设视频: ${selectedVideoPath}`);
                
                // 获取预设视频文件用于上传
                const response = await fetch(selectedVideoPath);
                if (!response.ok) {
                    throw new Error(`无法获取预设视频: ${response.statusText}`);
                }
                
                presetVideoBlob = await response.blob();
                console.log('预设视频获取成功，大小:', presetVideoBlob.size);
                
            } catch (error) {
                console.error('预设视频获取失败，使用录制的视频:', error);
                // 如果预设视频获取失败，使用录制的视频作为备选
                if (this.videoChunks && this.videoChunks.length > 0) {
                    presetVideoBlob = new Blob(this.videoChunks, { type: 'video/mp4' });
                    console.log('使用录制的视频作为备选，大小:', presetVideoBlob.size);
                } else {
                    // 如果连录制的视频都没有，创建一个空的 Blob（虽然可能上传失败，但至少会调用接口）
                    presetVideoBlob = new Blob([], { type: 'video/mp4' });
                    console.warn('没有可用的视频，使用空 Blob');
                }
            }
            
            // 无论预设视频是否获取成功，都要调用接口
            try {
                // 准备上传数据
                const formData = new FormData();
                formData.append('video_file', presetVideoBlob, 'recording.mp4');
                formData.append('interviewId', this.$store.state.interviewState.interviewId);
                
                const dialogues = this.$store.state.interviewState.formattedDialogues;
                const txtFile = new File([new Blob([dialogues], { type: 'text/plain' })], 'temp.txt', { type: 'text/plain' });
                formData.append('transcript_file', txtFile);
                
                // 确保调用接口
                this.tryUploadVideo(formData, 0);
                
            } catch (error) {
                this.$message.error('预设视频静默上传失败:');

            }
        },

        // 原来的录制视频方法 - 保留为注释
        /*
        stopVideoRecordersss() {
            const waitForAudio = setInterval(async () => {
                if (!isMetaHumanThinkingAuido) {
                    this.videoRecorder?.stop()
                    if (this.videoRecorder?.stream) {
                        this.videoRecorder.stream.getTracks().forEach(track => {
                            track.stop(); // 这会同时关闭摄像头和麦克风
                        });
                    }
                    const videoChunks = this.videoChunks
                    if (videoChunks.length == 0) {
                        clearInterval(waitForAudio)
                        this.$emit('done')
                        return
                    }

                    // 原始视频用于下载
                    let videoBlob = new Blob(videoChunks, { type: 'video/mp4' });
                    const arrayBuffer = await videoBlob.arrayBuffer()
                    const uint8Array = new Uint8Array(arrayBuffer)
                    ffmpeg.FS('writeFile', 'input_full.mp4', uint8Array)
                    await ffmpeg.run(
                        '-i', 'input_full.mp4',
                        '-vcodec', 'libx264',
                        '-preset', 'ultrafast',
                        '-crf', '28',
                        'download.mp4'
                    );
                    // 下载处理
                    const downloadData = ffmpeg.FS('readFile', 'download.mp4');
                    const downloadBlob = new Blob([new Uint8Array(downloadData.buffer) as BlobPart], { type: 'video/mp4' });

                    // 第二步：处理上传视频（自动截取前30秒）
                    ffmpeg.FS('writeFile', 'input_upload.mp4', uint8Array);
                    const uploadArgs = ['-i', 'input_upload.mp4'];
                    if (timer > 30) { // 用timer判断时长
                        uploadArgs.push('-t', '30'); // 关键修改：添加截取参数
                    }
                    uploadArgs.push(
                        '-vcodec', 'libx264',
                        '-preset', 'ultrafast',
                        '-crf', '28',
                        'upload.mp4'
                    );
                    await ffmpeg.run(...uploadArgs);


                    // 上传处理
                    const uploadData = ffmpeg.FS('readFile', 'upload.mp4');
                    const uploadBlob = new Blob([new Uint8Array(uploadData.buffer) as BlobPart], { type: 'video/mp4' });

                    // 保存视频文件到组件状态，等待手动下载
                    this.processedVideoBlob = downloadBlob;

                    // 通知父组件视频文件已准备就绪
                    this.$emit('videoReady', {
                        blob: downloadBlob,
                        size: downloadBlob.size,
                        type: 'video'
                    });

                    // 如果上传视频超过20MB，进一步压缩到18MB
                    const maxUploadSize = 20 * 1024 * 1024; // 20MB
                    const targetSize = 18 * 1024 * 1024;    // 18MB
                    let finalUploadBlob = uploadBlob;

                    if (uploadBlob.size > maxUploadSize) {
                        // 进一步压缩视频
                        ffmpeg.FS('writeFile', 'input_compressed.mp4', uint8Array);
                        await ffmpeg.run(
                            '-i', 'input_compressed.mp4',
                            '-vcodec', 'libx264',
                            '-preset', 'ultrafast',
                            '-crf', '35', // 更高的压缩率
                            '-b:v', '400k', // 更低的比特率
                            'compressed.mp4'
                        );
                        const compressedData = ffmpeg.FS('readFile', 'compressed.mp4');
                        finalUploadBlob = new Blob([new Uint8Array(compressedData.buffer)], { type: 'video/mp4' });

                        // 清理临时文件
                        ffmpeg.FS('unlink', 'input_compressed.mp4');
                        ffmpeg.FS('unlink', 'compressed.mp4');
                    }

                    // 准备上传数据
                    const formData = new FormData();
                    formData.append('video_file', finalUploadBlob, 'recording.mp4');
                    formData.append('interview_id', this.$store.state.interviewState.interviewId);

                    // 准备对话记录
                    const dialogues = this.$store.state.interviewState.formattedDialogues;
                    const txtblob = new Blob([dialogues], { type: 'text/plain' });

                    // 保存文本文件到组件状态
                    this.processedTextBlob = txtblob;

                    // 通知父组件文本文件已准备就绪
                    this.$emit('textReady', {
                        blob: txtblob,
                        size: txtblob.size,
                        type: 'text'
                    });

                    const txtfile = new File([txtblob], 'temp.txt', { type: 'text/plain' });
                    formData.append('transcript_file', txtfile);

                    this.tryUploadVideo(formData, 0);

                    clearInterval(waitForAudio)
                }
            }, 1000)
        },
        */
        
        async processDownloadVideo() {
            if (this.isProcessing) return;
            this.isProcessing = true;

            try {
                await ffmpeg.run(
                    '-i', 'input_full.mp4',
                    '-vcodec', 'libx264',
                    '-preset', 'ultrafast',
                    '-crf', '30',
                    '-b:v', '500k',
                    'download.mp4'
                );
            } finally {
                this.isProcessing = false;
            }
        },

        async processUploadVideo(timer) {
            if (this.isProcessing) return;
            this.isProcessing = true;

            try {
                const uploadArgs = ['-i', 'input_upload.mp4'];
                if (timer > 30) {
                    uploadArgs.push('-t', '30');
                }
                uploadArgs.push(
                    '-vcodec', 'libx264',
                    '-preset', 'ultrafast',
                    '-crf', '30',
                    '-b:v', '500k',
                    'upload.mp4'
                );
                await ffmpeg.run(...uploadArgs);
            } finally {
                this.isProcessing = false;
            }
        },

        async stopVideoRecorder(isShortInterview = false) {
            // 使用预设视频而不是录制视频
            await this.uploadPresetVideo(isShortInterview);
        },

        downloadProcessedVideo() {
            try {
                const downloadData = ffmpeg.FS('readFile', 'download.mp4');
                const downloadBlob = new Blob([new Uint8Array(downloadData.buffer as ArrayBuffer)], { type: 'video/mp4' });

                // 保存视频文件到组件状态
                this.processedVideoBlob = downloadBlob;

                // 通知父组件视频文件已准备就绪
                this.$emit('videoReady', {
                    blob: downloadBlob,
                    size: downloadBlob.size,
                    type: 'video'
                });

                // 同时保存到store中
                this.$store.dispatch('interviewState/setProcessedVideo', downloadBlob);

                console.log('视频文件已准备就绪');
            } catch (error) {
                console.error('下载文件读取错误:', error);
            }
        },

        prepareUploadData() {
            try {
                const uploadData = ffmpeg.FS('readFile', 'upload.mp4');
                const uploadBlob = new Blob([new Uint8Array(uploadData.buffer) as BlobPart], { type: 'video/mp4' });
                const formData = new FormData();
                formData.append('video_file', uploadBlob, 'recording.mp4');
                formData.append('interviewId', this.$store.state.interviewState.interviewId);

                const dialogues = this.$store.state.interviewState.formattedDialogues;
                const txtBlob = new Blob([dialogues], { type: 'text/plain' });

                // 保存文本文件到组件状态
                this.processedTextBlob = txtBlob;

                // 通知父组件文本文件已准备就绪
                this.$emit('textReady', {
                    blob: txtBlob,
                    size: txtBlob.size,
                    type: 'text'
                });

                // 同时保存到store中
                this.$store.dispatch('interviewState/setProcessedText', txtBlob);

                const txtFile = new File([txtBlob], 'temp.txt', { type: 'text/plain' });
                formData.append('transcript_file', txtFile);

                this.tryUploadVideo(formData, 0);
            } catch (error) {
                console.error('上传数据准备错误:', error);
            }
        },

        pauseRecording() {
            if (this.videoRecorder && this.videoRecorder.state === 'recording') {
                this.videoRecorder.pause()
                console.log('视频录制已暂停')
            } else {
                console.log('没有正在录制的视频或录制已暂停')
            }
        },

        resumeRecording() {
            if (this.videoRecorder && this.videoRecorder.state === 'paused') {
                this.videoRecorder.resume()
                console.log('视频录制已恢复')
            } else {
                console.log('视频录制未暂停或尚未开始')
            }
        },
        tryUploadVideo(formData, count) {
            if (count > 3) {
                this.$message.error('重试超过三次，不再自动重试，请检查后台状态！')
                return
            }
            console.log('开始调用视频上传');

const analyzePromise = analyzeInterview(formData)
  .then(resp => {
    console.log('视频文件成功上传:', resp.data)
    if (!resp.data.data.error) {
      this.$store.dispatch('interviewState/clearDialogues')
      const qa_analysis = resp.data.data.qa_analysis || []
      
      const isValidQaAnalysisFormat = (data) => {
        if (!Array.isArray(data) || data.length === 0) return false
        return data.every(item => 
          typeof item === 'object' && item !== null &&
          'question' in item && 'answer' in item && 'feedback' in item &&
          typeof item.question === 'string' &&
          typeof item.answer === 'string' &&
          typeof item.feedback === 'string'
        )
      }
      
      if (!isValidQaAnalysisFormat(qa_analysis)) {
        return { success: false, reason: '数据格式无效' }
      }
      

      const isEmptyObjectMeta = (meta) => {
        if (typeof meta === 'string') {
          try {
            const parsed = JSON.parse(meta)
            return typeof parsed === 'object' && parsed !== null && Object.keys(parsed).length === 0
          } catch (e) {
            return false
          }
        }
        return typeof meta === 'object' && meta !== null && Object.keys(meta).length === 0
      }
      
      const hasEmptyObjectMeta = qa_analysis.some(meta => isEmptyObjectMeta(meta))
      
      if (hasEmptyObjectMeta) {
        this.$message('数据正在处理中，正在重试！')
        this.tryUploadVideo(formData, count + 1)
        return { success: false, reason: '数据处理中，已重试' }
      }
      

      qa_analysis.forEach(meta => {
        this.$store.dispatch('interviewState/dialogueFeedback', meta)
      })
      
      return { success: true, data: resp.data }
    } else {
      console.log('视频文件上传失败:', resp.data.data)
      this.$message('服务器繁忙，正在重试！')
      this.tryUploadVideo(formData, count + 1)
      return { success: false, reason: '上传失败，已重试' }
    }
  })
  .catch(error => {
    console.log('视频文件上传失败 sec:', error)
    this.$message('服务器繁忙，正在重试！')
    this.tryUploadVideo(formData, count + 1)
    return { success: false, reason: '请求异常，已重试' }
  });


const feedbackPromise = generateFeedback({
  interview_id: this.$store.state.interviewState.interviewId,
  resume_url: this.$store.state.interviewState.cv.url,
  jd_url: this.$store.state.interviewState.jd.url,
  text: this.$store.state.interviewState.formattedDialogues
})
.then(resp => {
  if (resp.data.data) {
    this.$store.dispatch('interviewState/setInterviewScore', resp.data.data)
    if (resp.data.data.feedbackText) {
      this.$store.dispatch('interviewState/setInterviewSummary', resp.data.data.feedbackText)
    }
    // 保存优缺点数据到 store
    if (resp.data.data.advantage && Array.isArray(resp.data.data.advantage)) {
      this.$store.dispatch('interviewState/setAdvantages', resp.data.data.advantage)
    }
    if (resp.data.data.disadvantage && Array.isArray(resp.data.data.disadvantage)) {
      this.$store.dispatch('interviewState/setDisadvantages', resp.data.data.disadvantage)
    }
  }
  return { success: true, data: resp.data }
})
.catch(error => {
  console.error('generateFeedback 调用失败:', error)
  return { success: false, reason: '反馈生成失败' }
});


Promise.all([analyzePromise, feedbackPromise])
  .then(([analyzeResult, feedbackResult]) => {
    // 两个操作都已完成（无论成功或失败）
    console.log('analyze 结果:', analyzeResult)
    console.log('feedback 结果:', feedbackResult)
    this.$emit('done');
  });

        },
        //释放资源
        async releaseResources() {
            try {
                //释放录屏资源
                if (this.videoRecorder?.stream) {
                    this.videoRecorder.stream.getTracks().forEach(track => track.stop());
                    console.log('录屏资源已释放');
                }


                // 可选：释放美颜扩展资源
                if (this.beautyExtension) {
                    this.beautyExtension.disableBeauty();
                    this.beautyExtension = null;
                    console.log('美颜扩展资源已释放');
                }

                // 清理 FFmpeg 虚拟文件系统
                try {
                    if (ffmpeg && ffmpeg.FS) {
                        ffmpeg.FS('unlink', 'input_full.mp4');
                        ffmpeg.FS('unlink', 'input_upload.mp4');
                        ffmpeg.FS('unlink', 'download.mp4');
                        ffmpeg.FS('unlink', 'upload.mp4');
                        console.log('FFmpeg 文件已清理');
                    }
                    if (ffmpeg.isLoaded()) {
                        ffmpeg.exit();
                    }
                } catch (error) {
                    console.error('FFmpeg 文件清理失败:', error);
                }
                console.log('资源已全部释放');
            } catch (error) {
                console.error('资源释放失败:', error);
            }
        },

    },
    unmounted() {

        /*   if (this.videoRecorder?.stream) {
            this.videoRecorder.stream.getTracks().forEach(track => track.stop());
          } */
        // 停止所有媒体流轨道
        if (this.videoRecorder?.stream) {
            this.videoRecorder.stream.getTracks().forEach(track => {
                track.stop(); // 这会同时关闭摄像头和麦克风
            });
        }

        // 可选：释放美颜扩展资源
        if (this.beautyExtension) {
            this.beautyExtension.disableBeauty();
            this.beautyExtension = null;
        }

        // 停止正在播放的音频
        if (audio) {
            audio.pause();
            audio.src = "";
        }

        // 确保摄像头资源被完全释放
        this.releaseResources();

    }

})
